(function () {
  if (window.Shopify && Shopify.designMode) return;
  var path = location.pathname || '';
  if (path.indexOf('/checkout') === 0 || path.indexOf('/thank') !== -1) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Bundle offer from Theme settings → SSC Bundle offer (snippets/ssc-offer.liquid on <html>).
  var root = document.documentElement.dataset;
  var enabled = root.sscOfferEnabled !== 'false';
  var BUY = Math.max(1, parseInt(root.sscOfferBuy, 10) || 3);
  var GET = Math.max(1, parseInt(root.sscOfferGet, 10) || 1);
  var GROUP = BUY + GET;
  var onBundler = path.indexOf('/pages/bundler') !== -1;
  var onCart = path === '/cart' || path.indexOf('/cart/') === 0;
  var toast = document.querySelector('[data-ssc-toast]');
  var pill = document.querySelector('[data-ssc-trk]');
  var meter = document.querySelector('[data-ssc-b3]');
  var lastN = null;
  var timer = 0;
  var toastTimer = 0;
  var hidden = false;
  try { hidden = sessionStorage.getItem('ssc-b3g1-hide') === '1'; } catch (e) { hidden = false; }

  var ICONS = {
    shorts: '<svg viewBox="0 0 32 32" fill="none" stroke="#151515" stroke-width="2.2" stroke-linejoin="round"><path d="M7 5h18l3 21-9 1.5L16 15l-3 12.5L4 26z" fill="#b8e7f7"/><path d="M7 9h18"/></svg>',
    tee: '<svg viewBox="0 0 32 32" fill="none" stroke="#151515" stroke-width="2.2" stroke-linejoin="round"><path d="M11 4l-7 4 3 6 3-1.5V28h12V12.5l3 1.5 3-6-7-4c-1 2-3 3-5 3s-4-1-5-3z" fill="#f5b98a"/></svg>',
    jersey: '<svg viewBox="0 0 32 32" fill="none" stroke="#151515" stroke-width="2.2" stroke-linejoin="round"><path d="M11 4l-7 4 3 6 3-1.5V28h12V12.5l3 1.5 3-6-7-4l-5 6z" fill="#dccdf2"/><path d="M13 18h6M16 15v8"/></svg>',
    tank: '<svg viewBox="0 0 32 32" fill="none" stroke="#151515" stroke-width="2.2" stroke-linejoin="round"><path d="M11 4c0 4 2 6 5 6s5-2 5-6h3c0 4 1 6 3 8v16H5V12c2-2 3-4 3-8z" fill="#f6c6d2"/></svg>',
    hoodie: '<svg viewBox="0 0 32 32" fill="none" stroke="#151515" stroke-width="2.2" stroke-linejoin="round"><path d="M12 4c-1 3 1 6 4 6s5-3 4-6l7 4 2 18h-5V14v14H8V14v12H3L5 8z" fill="#ffda29"/><path d="M14 12v4M18 12v4"/></svg>',
    joggers: '<svg viewBox="0 0 32 32" fill="none" stroke="#151515" stroke-width="2.2" stroke-linejoin="round"><path d="M9 4h14l2 24h-6l-3-16-3 16H7z" fill="#bfe8cf"/><path d="M9 7.5h14"/></svg>',
    tag: '<svg viewBox="0 0 32 32" fill="none" stroke="#151515" stroke-width="2.2" stroke-linejoin="round"><path d="M5 5h11l12 12-11 11L5 16z" fill="#ece9e1"/><circle cx="11" cy="11" r="2.2"/></svg>'
  };

  function kindOf(item) {
    var t = (item.product_type || '').toLowerCase();
    var has = function () {
      for (var i = 0; i < arguments.length; i++) if (t.indexOf(arguments[i]) !== -1) return true;
      return false;
    };
    if (has('tank', 'bra')) return 'tank';
    if (has('jersey')) return 'jersey';
    if (has('hoodie', 'sweatshirt', 'quarter zip')) return 'hoodie';
    if (has('jogger', 'pajama', 'legging')) return 'joggers';
    if (has('t-shirt', 'tee', 'shirt')) return 'tee';
    if (has('short', 'mesh')) return 'shorts';
    return 'tag';
  }

  function counts(item) {
    var title = (item.product_title || '').toLowerCase();
    var type = (item.product_type || '').toLowerCase();
    // Mirrors Shopify's Buy X get Y: mystery shorts count; shipping protection, gift cards and custom products don't.
    if (title.indexOf('shipping protection') !== -1) return false;
    if (title.indexOf('custom product') !== -1) return false;
    if (item.handle === 'kit-customization') return false; // the $7 custom-print fee (prompt 132)
    if (type.indexOf('gift card') !== -1) return false;
    return true;
  }

  // Cart lines come newest first; reverse so units run in the order they were added.
  function qualify(cart) {
    var units = [];
    var lines = (cart.items || []).filter(counts);
    lines.slice().reverse().forEach(function (item) {
      var kind = kindOf(item);
      for (var i = 0; i < (item.quantity || 0); i++) units.push({ kind: kind, key: item.key });
    });
    return { n: units.length, units: units, lines: lines, cart: cart };
  }

  var prevQty = null;
  // Last added line (the diff below), kept for the session so the cart free-slot scroller can follow it after a page change.
  var lastKey = null;
  try { lastKey = sessionStorage.getItem('ssc-last-line'); } catch (e) { lastKey = null; }
  function addedLine(state) {
    var found = null;
    if (prevQty) {
      state.lines.forEach(function (item) {
        if (!found && (item.quantity || 0) > (prevQty[item.key] || 0)) found = item;
      });
    }
    return found || state.lines[0] || null;
  }

  function ordinal(k) {
    var t = k % 100;
    var u = k % 10;
    var suffix = t >= 11 && t <= 13 ? 'th' : u === 1 ? 'st' : u === 2 ? 'nd' : u === 3 ? 'rd' : 'th';
    return k + suffix;
  }

  function plural(k, word) {
    return k + ' ' + word + (k === 1 ? '' : 'S');
  }

  // Free items earned so far: GET per full group, plus free units already in the open group.
  function freeCount(n) {
    return Math.floor(n / GROUP) * GET + Math.max(0, (n % GROUP) - BUY);
  }

  // "GET THE 4TH" / "GET THE 3RD & 4TH" / "GET 3" (+ " FREE" by the caller).
  function nthPhrase() {
    if (GET > 2) return 'GET ' + GET;
    var out = [];
    for (var k = BUY + 1; k <= GROUP; k++) out.push(ordinal(k).toUpperCase());
    return 'GET THE ' + out.join(' & ');
  }

  function copy(n) {
    if (!enabled) return { text: '', toast: '' };
    var c = n % GROUP;
    var f = Math.floor(n / GROUP);
    var free = freeCount(n);
    var next = ordinal(free + 1);
    var need = BUY - c;
    var msg;
    var note;
    if (n === 0) {
      msg = 'ADD ' + plural(BUY, 'ITEM') + ', ' + nthPhrase() + ' <b>FREE</b>';
      note = '';
    } else if (c === 0) {
      var items = plural(free, 'FREE ITEM');
      msg = '<b>' + items + ' UNLOCKED</b> · ADD ' + BUY + ' MORE FOR ' + (GET === 1 ? 'YOUR ' + next.toUpperCase() : GET + ' MORE FREE');
      note = items.toLowerCase() + ' unlocked';
    } else if (c >= BUY) {
      var left = GROUP - c;
      if (left > 1) {
        msg = 'YOUR NEXT ' + left + ' ITEMS ARE <b>FREE</b>';
        note = 'Your next ' + left + ' items are free';
      } else {
        msg = free ? 'YOUR NEXT ITEM IS YOUR <b>' + next.toUpperCase() + ' FREE ONE</b>' : 'YOUR NEXT ITEM IS <b>FREE</b>';
        note = 'Your next item is free';
      }
    } else if (GET > 1) {
      msg = 'ADD ' + need + ' MORE TO GET <b>' + GET + (f ? ' MORE' : '') + ' FREE ITEMS</b>';
      note = need + ' more for ' + GET + (f ? ' more' : '') + ' free items';
    } else if (f) {
      msg = 'ADD ' + need + ' MORE TO GET YOUR <b>' + next.toUpperCase() + ' FREE ITEM</b>';
      note = need + ' more for your ' + next + ' free item';
    } else {
      msg = 'ADD ' + need + ' MORE TO GET A <b>FREE ITEM</b>';
      note = need + ' more for a free item';
    }
    return { text: msg, toast: note };
  }

  // Floating bar (E2): one short line + one pill per item in the current set.
  function barCopy(n) {
    var c = n % GROUP;
    var full = n > 0 && c === 0;
    var msg;
    if (full) msg = '<b>' + plural(freeCount(n), 'FREE ITEM') + ' UNLOCKED</b>';
    else if (c < BUY) msg = 'ADD ' + (BUY - c) + ' MORE, GET ' + (GET > 1 ? GET + ' ' : '') + '<b>FREE</b>';
    else if (GROUP - c > 1) msg = 'YOUR NEXT ' + (GROUP - c) + ' ITEMS ARE <b>FREE</b>';
    else msg = 'YOUR NEXT ITEM IS <b>FREE</b>';
    var pills = '';
    var filled = full ? GROUP : c;
    for (var i = 1; i <= GROUP; i++) {
      var free = i > BUY;
      var done = i <= filled;
      pills += '<span class="ssc-trk__pill' + (free ? ' is-free' : '') + (done ? ' is-done' : '') + '">' + (free ? 'FREE' : done ? '✓' : i) + '</span>';
    }
    // Under 380px the CSS swaps in this short line so nothing is cut off.
    var short;
    if (n === 0) short = 'MIX ANY ' + GROUP;
    else if (full) short = '<b>FREE UNLOCKED</b>';
    else if (c < BUY) short = (BUY - c) + ' MORE = <b>FREE</b>';
    else short = 'NEXT ' + (GROUP - c > 1 ? GROUP - c : 'ONE') + ' <b>FREE</b>';
    var plain = msg.replace(/<[^>]+>/g, '').toLowerCase();
    return { msg: msg, short: short, pills: pills, say: plain.charAt(0).toUpperCase() + plain.slice(1) };
  }

  function strip(host, state, pop) {
    if (!host) return;
    host.innerHTML = '';
    var n = state.n;
    var total = Math.max(1, Math.ceil(n / GROUP));
    for (var s = 0; s < total; s++) {
      var items = state.units.slice(s * GROUP, s * GROUP + GROUP);
      var done = items.length === GROUP;
      var set = document.createElement('div');
      set.className = 'ssc-b3s__set' + (done ? ' is-done' : '');
      var label = document.createElement('span');
      label.className = 'ssc-b3s__n';
      label.textContent = done ? 'Free #' + (s + 1) + ' ✓' : 'Set ' + (s + 1);
      set.appendChild(label);
      for (var i = 0; i < GROUP; i++) {
        var unit = items[i];
        var slot = document.createElement('span');
        if (i >= BUY) {
          slot.className = 'ssc-slot is-free' + (unit ? '' : ' is-empty');
          slot.textContent = 'FREE';
        } else if (unit) {
          slot.className = 'ssc-slot';
          slot.innerHTML = ICONS[unit.kind];
        } else {
          slot.className = 'ssc-slot is-empty';
          slot.textContent = '+';
        }
        if (unit && s * GROUP + i === pop && !reduce) slot.classList.add('is-pop');
        set.appendChild(slot);
      }
      host.appendChild(set);
    }
    requestAnimationFrame(function () {
      host.scrollTo({ left: host.scrollWidth, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  function sheetOpen() {
    var menu = document.querySelector('[data-ssc-menu]');
    var drawer = document.querySelector('#cart-drawer');
    var dialog = document.querySelector('dialog[open], .ssc-mto-overlay:not([hidden])');
    return (menu && !menu.hidden) || (drawer && drawer.hasAttribute('open')) || !!dialog;
  }

  function placePill() {
    if (!pill) return;
    var sticky = document.querySelector('.ssc-sticky');
    var lift = 0;
    if (sticky && !sticky.hidden && getComputedStyle(sticky).display !== 'none') {
      var rect = sticky.getBoundingClientRect();
      if (rect.height > 0 && rect.bottom > 0) lift = Math.max(0, window.innerHeight - rect.top + 8);
    }
    pill.style.bottom = lift
      ? lift + 'px'
      : 'calc(12px + env(safe-area-inset-bottom))';
  }

  var lastState = null;
  function paint(state, pop) {
    lastState = state;
    var meters = document.querySelectorAll('[data-ssc-b3]');
    pill = document.querySelector('[data-ssc-trk]');
    toast = document.querySelector('[data-ssc-toast]');
    var info = copy(state.n);
    var f = freeCount(state.n);
    if (pop === undefined || pop === false) pop = -1;
    meters.forEach(function (node) {
      node.hidden = false;
      var count = node.querySelector('[data-ssc-b3-count]');
      var msg = node.querySelector('[data-ssc-b3-msg]');
      if (count) count.textContent = state.n ? state.n + ' item' + (state.n === 1 ? '' : 's') + ' · ' + f + ' free' : '';
      if (msg) msg.innerHTML = info.text;
      strip(node.querySelector('[data-ssc-b3-strip]'), state, pop);
    });
    if (!enabled || !pill) return;
    // The product page's sticky add-to-cart bar (prompt 118) takes this spot while it shows, and the bar also steps aside
    // while the main Add to cart sits where it would cover it (.is-guard, phones).
    var stickyOn = !!document.querySelector('.ssc-sticky.is-on, .ssc-sticky.is-guard');
    var show = state.n >= 1 && !hidden && !onBundler && !onCart && !stickyOn && !sheetOpen() && !(toast && toast.classList.contains('is-on'));
    pill.classList.toggle('is-away', !show);
    if (show) pill.hidden = false;
    var bar = barCopy(state.n);
    var text = pill.querySelector('[data-ssc-trk-t]');
    var shortText = pill.querySelector('[data-ssc-trk-s]');
    if (shortText && shortText.innerHTML !== bar.short) shortText.innerHTML = bar.short;
    var chain = pill.querySelector('[data-ssc-trk-pills]');
    var go = pill.querySelector('[data-ssc-trk-go]');
    var live = pill.querySelector('[data-ssc-trk-live]');
    if (text && text.innerHTML !== bar.msg) text.innerHTML = bar.msg;
    if (chain && chain.innerHTML !== bar.pills) chain.innerHTML = bar.pills;
    if (go) go.setAttribute('aria-label', bar.say + '. Open cart.');
    // Announce once per new message while the bar is on screen, not on every repaint.
    if (live && show && live.textContent !== bar.say) live.textContent = bar.say;
    placePill();
  }

  document.addEventListener('ssc:sticky', function () { if (lastState) paint(lastState, -1); });

  function openDrawer() {
    var drawer = document.querySelector('#cart-drawer');
    // Already open (an add from inside the drawer): opening again would move focus back to its close button.
    if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('open')) drawer.open();
  }

  function bump() {
    document.querySelectorAll('[data-ssc-cart-count]').forEach(function (node) {
      node.classList.remove('is-bump');
      void node.offsetWidth;
      node.classList.add('is-bump');
    });
  }

  function showToast(state, item) {
    if (!toast || !item) return;
    var info = copy(state.n);
    var img = toast.querySelector('img');
    var title = toast.querySelector('[data-ssc-toast-title]');
    var note = toast.querySelector('[data-ssc-toast-note]');
    var src = item.image || '';
    var srcset = '';
    if (src.indexOf('cdn.shopify.com') !== -1) {
      var q = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=';
      src = q + 150;
      srcset = q + '50 50w, ' + q + '100 100w, ' + q + '150 150w';
    }
    if (img) { img.sizes = '50px'; img.srcset = srcset; img.src = src; }
    if (title) title.textContent = (item.product_title || '') + (item.variant_title ? ' · ' + item.variant_title : '');
    if (note) note.textContent = info.toast;
    toast.classList.add('is-on');
    if (pill) pill.classList.add('is-away');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-on');
      paint(state, -1);
    }, 2600);
  }

  var seq = 0;
  function applyCart(cart, fromAdd) {
    var state = qualify(cart);
    var grew = lastN !== null && state.n > lastN;
    var finished = grew && state.n > 0 && state.n % GROUP === 0;
    var item = grew ? addedLine(state) : null;
    var pop = -1;
    if (fromAdd && item) {
      for (var i = state.units.length - 1; i >= 0; i--) {
        if (state.units[i].key === item.key) { pop = i; break; }
      }
    }
    paint(state, pop);
    if (fromAdd && grew) {
      bump();
      if (finished && !onBundler && enabled) {
        if (toast) toast.classList.remove('is-on');
        setTimeout(openDrawer, 250);
      } else if (!sheetOpen() || onBundler) {
        showToast(state, item);
      }
    }
    lastN = state.n;
    prevQty = {};
    state.lines.forEach(function (line) { prevQty[line.key] = line.quantity || 0; });
    if (item) lastKey = item.key;
    if (!state.lines.some(function (line) { return line.key === lastKey; })) lastKey = state.lines[0] ? state.lines[0].key : null;
    try { if (lastKey) sessionStorage.setItem('ssc-last-line', lastKey); } catch (e) {}
    window.sscCartState = { cart: cart, lastKey: lastKey };
    document.dispatchEvent(new CustomEvent('ssc:cart', { detail: window.sscCartState }));
    var drawer = document.querySelector('#cart-drawer');
    if (onCart || (drawer && drawer.hasAttribute('open'))) loadFreeSlot();
    return state;
  }

  // Cart free-slot scroller (snippets/ssc-free-slot.liquid): its script loads the first time the drawer opens with items, or on /cart.
  var freeSlotAsked = false;
  function loadFreeSlot() {
    if (freeSlotAsked || window.sscFreeSlot) return;
    var host = document.querySelector('[data-ssc-fs]');
    if (!host || !host.dataset.src) return;
    freeSlotAsked = true;
    // The shared pool (assets/ssc-pool.js) first; async = false keeps the two in order. The homepage gacha may have loaded it already.
    [window.SSCPool ? null : host.dataset.poolSrc, host.dataset.src].forEach(function (src) {
      if (!src) return;
      var script = document.createElement('script');
      script.src = src;
      script.async = false;
      document.head.appendChild(script);
    });
  }

  function refresh(fromAdd, after) {
    var mine = ++seq;
    var run = function () {
      fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
        if (mine !== seq) return;
        applyCart(cart, fromAdd);
      }).catch(function () {});
    };
    if (after && typeof after.then === 'function') after.then(run, run);
    else run();
  }

  window.sscMangaAfterAdd = function (payload) { refresh(true, payload && payload.promise); };
  document.addEventListener('shopify:cart:lines-update', function (event) { refresh(true, event && event.promise); });
  document.addEventListener('theme-drawer:open', function () { loadFreeSlot(); if (lastN !== null) refresh(false); });
  document.addEventListener('theme-drawer:close', function () { if (lastN !== null) refresh(false); });

  if (pill) {
    pill.querySelector('[data-ssc-trk-go]')?.addEventListener('click', openDrawer);
    pill.querySelector('[data-ssc-trk-x]')?.addEventListener('click', function () {
      hidden = true;
      try { sessionStorage.setItem('ssc-b3g1-hide', '1'); } catch (e) {}
      pill.classList.add('is-away');
    });
  }
  toast?.querySelector('[data-ssc-toast-cart]')?.addEventListener('click', function () {
    toast.classList.remove('is-on');
    openDrawer();
  });

  refresh(false);
})();

// "i" info dialog (snippets/ssc-info.liquid): bottom sheet under 750px, popover under the "i" on desktop.
(function () {
  var dlg = document.querySelector('[data-ssc-info-dlg]');
  if (!dlg) return;
  var body = dlg.querySelector('[data-ssc-info-body]');
  var opener = null;
  function place() {
    var r = opener.getBoundingClientRect();
    var w = dlg.offsetWidth;
    var h = dlg.offsetHeight;
    var left = Math.max(12, Math.min(r.right - w + 16, innerWidth - w - 12));
    var below = r.bottom + 12 + h <= innerHeight - 12;
    var up = !below && r.top - 12 - h >= 12;
    // Fits neither side: clamp into the viewport and drop the arrow.
    var top = below ? r.bottom + 12 : up ? r.top - 12 - h : Math.max(12, innerHeight - h - 12);
    dlg.classList.toggle('is-up', up);
    dlg.classList.toggle('is-free', !below && !up);
    dlg.style.left = left + 'px';
    dlg.style.top = top + 'px';
    dlg.style.setProperty('--ax', Math.max(10, Math.min(r.left + r.width / 2 - left - 7, w - 24)) + 'px');
  }
  function open(btn) {
    var tpl = document.querySelector('template[data-ssc-info-tpl="' + btn.dataset.sscInfo + '"]');
    if (!tpl) return;
    opener = btn;
    body.replaceChildren(tpl.content.cloneNode(true));
    body.querySelectorAll('[data-row]').forEach(function (row) {
      row.classList.toggle('is-here', row.dataset.row === btn.dataset.sscInfoHere);
    });
    var sheet = innerWidth < 750;
    dlg.classList.toggle('is-sheet', sheet);
    dlg.classList.toggle('is-pop', !sheet);
    dlg.style.left = dlg.style.top = '';
    dlg.showModal();
    if (!sheet) place();
    dlg.querySelector('[data-ssc-info-close]')?.focus();
  }
  // Capture phase: the "i" never reaches the product card link, quick add or a drawer behind it
  // (presses and focus too: the card prefetches its product page on focusin).
  ['pointerdown', 'mousedown', 'touchstart', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (e.target.closest && e.target.closest('[data-ssc-info]')) e.stopPropagation();
    }, { capture: true, passive: true });
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ssc-info]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open(btn);
  }, true);
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || e.target.closest('[data-ssc-info-close]')) dlg.close();
  });
  // Esc closes only this pop-up, not a cart drawer or quick add underneath.
  dlg.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    e.preventDefault();
    e.stopPropagation();
    dlg.close();
  });
  dlg.addEventListener('close', function () {
    if (opener) opener.focus();
    opener = null;
  });
  function away(e) {
    if (dlg.open && dlg.classList.contains('is-pop') && !(e.target instanceof Node && dlg.contains(e.target))) dlg.close();
  }
  addEventListener('resize', away);
  document.addEventListener('scroll', away, true);
})();

// Chatty chat bubble (app embed, bottom-right) stays in one spot (ssc-global.css). Prompt 133: it used to rise above
// whichever bar was showing and hopped up and down with them; now it only shows or hides (ssc-manga.css). Phones: hidden
// on product pages and the bundler (html.ssc-chat-page-off), where the bottom bars live. Any width: hidden while the
// offer bar or the added-to-cart toast shows. The gacha tray scrolls with the page, so the bubble fades out while the
// tray is under its corner (html.ssc-chat-tucked). While the cart drawer is open the bubble drops under it (on desktop
// the drawer isn't a modal, so it needs telling).
(function () {
  var root = document.documentElement;
  root.classList.toggle('ssc-chat-page-off', /\/products\/|\/pages\/bundler/.test(location.pathname));
  function visible(el) {
    if (!el || el.hidden) return null;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return null;
    var r = el.getBoundingClientRect();
    return r.height > 0 && r.top < window.innerHeight && r.bottom > 0 ? r : null;
  }
  function update() {
    root.classList.toggle('ssc-cart-open', !!document.querySelector('#cart-drawer[open]'));
    var bubble = document.querySelector('.Avada-Faqs_Button');
    var t = bubble && visible(document.querySelector('.ssc-g__tray'));
    var tucked = false;
    if (t) {
      var b = (bubble.querySelector('#Avada-FAQ_WidgetTrigger') || bubble).getBoundingClientRect();
      tucked = t.left < b.right && t.right > b.left && t.top < b.bottom + 8 && t.bottom > b.top - 8;
    }
    root.classList.toggle('ssc-chat-tucked', tucked);
  }
  var queued = false;
  function soon() { if (!queued) { queued = true; requestAnimationFrame(function () { queued = false; update(); }); } }
  window.addEventListener('scroll', soon, { passive: true, capture: true });
  window.addEventListener('resize', soon);
  if (window.MutationObserver) {
    new MutationObserver(soon).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
    var waitBubble = new MutationObserver(function () {
      if (!document.querySelector('.Avada-Faqs_Button')) return;
      waitBubble.disconnect();
      soon();
    });
    if (!document.querySelector('.Avada-Faqs_Button')) waitBubble.observe(document.body, { childList: true, subtree: true });
  } else {
    setInterval(update, 500);
  }
  update();
})();

// Cart drawer "Have a code?" (snippets/ssc-cart-code.liquid): opens the one-line discount code field in the footer.
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-ssc-code-toggle]');
  if (!b) return;
  var form = document.getElementById(b.getAttribute('aria-controls'));
  if (!form) return;
  var open = form.hidden;
  form.hidden = !open;
  b.setAttribute('aria-expanded', open ? 'true' : 'false');
  if (open) { var input = form.querySelector('input'); if (input) input.focus(); }
});
